// =============================================================================
// Formatting utilities — UK date format throughout (DD/MM/YYYY).
// =============================================================================

/** Format ISO date string to UK format DD/MM/YYYY */
export function fmtDate(iso: string | null | undefined): string {
  if (!iso) return '—'
  const s = String(iso).slice(0, 10)
  const [y, m, d] = s.split('-')
  if (!d) return s
  return `${d}/${m}/${y}`
}

/** Format ISO timestamp to UK format DD/MM/YYYY HH:mm */
export function fmtDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const dt = new Date(iso)
  const d = String(dt.getDate()).padStart(2, '0')
  const m = String(dt.getMonth() + 1).padStart(2, '0')
  const y = dt.getFullYear()
  const h = String(dt.getHours()).padStart(2, '0')
  const min = String(dt.getMinutes()).padStart(2, '0')
  return `${d}/${m}/${y} ${h}:${min}`
}

/** Format number with locale separators */
export function fmtNum(n: number | null | undefined): string {
  if (n == null) return '—'
  return n.toLocaleString('en-GB')
}

/** Display a value (null/undefined → '—') */
export function displayValue(v: unknown): string {
  if (v === null || v === undefined || v === '') return '—'
  if (typeof v === 'boolean') return v ? 'Yes' : 'No'
  return String(v)
}
